import {
  FormControlLabel as MUIFormControlLabel,
  FormControlLabelProps,
  styled,
} from '@mui/material'
import { useRadioGroup } from '@mui/material/RadioGroup'
import { lighten } from '@mui/system/colorManipulator'
import clsx from 'clsx'

const StyledFormControlLabel = styled(MUIFormControlLabel, {
  shouldForwardProp: (prop) => prop !== 'checked',
})(({ theme, checked }) => ({
  ...(checked! && {
    backgroundColor: lighten(theme.palette.primary.main, 0.97),
    borderColor: lighten(theme.palette.primary.main, 0.75),
  }),
}))

export default function FormControlLabel(props: FormControlLabelProps): JSX.Element {
  const radioGroup = useRadioGroup()
  const isChecked = radioGroup?.value === props.value ?? false

  return (
    <StyledFormControlLabel
      className={clsx('control-label', { 'control-label--checked': isChecked })}
      checked={isChecked}
      {...props}
    />
  )
}
